/**
 * Renderer for the target value of an asset tag inventory model.
 * If the current has been edited, display the target value with full opacity to indicate the overriding value.
 * In the case of an error, display a red border/icon and message. There is only one error condition (empty value).
 */
import React from 'react';
import { Flex, Icon, Text } from 'core/components';
import AssetTagInventoryModel from 'app/stores/assetTags/AssetTagInventoryModel';

interface Props {
  model: AssetTagInventoryModel;
  value: string;
}

function targetValueRenderer({ model, value }: Props) {
  if (model.hasError) {
    return (
      <Flex alignItems="center" px={1} gap={1} border="danger" height={30} width={220}>
        <Icon icon="error" color="danger" />
        <Text fontStyle="italic" muted>
          Select a group value
        </Text>
      </Flex>
    );
  }

  return <Text opacity={model.isNewValue || model.valueEdited ? 1 : 0.3}>{value}</Text>;
}

export default targetValueRenderer;
